import { render, staticRenderFns } from "./GongGaoGongShiView.vue?vue&type=template&id=270c4c1e&scoped=true"
import script from "./GongGaoGongShiView.vue?vue&type=script&lang=js"
export * from "./GongGaoGongShiView.vue?vue&type=script&lang=js"
import style0 from "./GongGaoGongShiView.vue?vue&type=style&index=0&id=270c4c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c4c1e",
  null
  
)

export default component.exports